import { Grid, styled } from "@mui/material";

const KeyGrid = styled(Grid)({
    fontWeight: "bold",
    height: '3em',
    marginBottom: '4px',
    float:'left',
    marginRight:'0.2em',
    overflow:'hidden',
    textOverflow:'ellipsis'
});

export default KeyGrid;